import { FACEBOOK_ERRORS, FACEBOOK_ERRORS_BASE } from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';
import { FacebookErrorModel } from '../model/FacebookErrorModel';

type AllRes = { facebookErrors: FacebookErrorModel[] };

class FacebookErrorController extends AuthenticatedController {
  static getAll(pageId: number): Promise<AllRes> {
    return super.get(FACEBOOK_ERRORS(pageId));
  }

  static deleteFacebookError(pageId: number, fbErrorId, ignore: boolean) {
    return super.delete(FACEBOOK_ERRORS_BASE(pageId, fbErrorId), { ignore });
  }
}

export default FacebookErrorController;
